import Icons from "../constants/icon.constant";
import PrimaryIcon from "./PrimaryIcon";

interface BrandProps {
  size?: "sm" | "md" | "lg" | "xl";
}

export default function Brand({ size = "lg" }: Readonly<BrandProps>) {
  const sizeMap = {
    sm: { logo: { width: 16, height: 16 }, name: { width: 64, height: 16 } },
    md: { logo: { width: 20, height: 20 }, name: { width: 80, height: 20 } },
    lg: { logo: { width: 24, height: 24 }, name: { width: 100, height: 24 } },
    xl: { logo: { width: 36, height: 36 }, name: { width: 132, height: 36 } },
  };

  const selected = sizeMap[size];

  return (
    <div className="flex items-center gap-2">
      <PrimaryIcon icon={Icons.BrandLogo(selected.logo)} isActive />
      <PrimaryIcon icon={Icons.BrandName(selected.name)} isActive={false} />
    </div>
  );
}
